import {Component, Input, OnInit} from '@angular/core';
import {UserService} from '../../../services/user.service';
import {UserVO} from '../../../generate/UserVO';

@Component({
  selector: 'user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit {
  user: UserVO;

  @Input()
  signUpMode: Boolean = false;

  editMode: boolean;

  constructor(private userService: UserService) {
  }


  ngOnInit(): void {
    this.getUserDetails();
    if (this.signUpMode) {
      this.editMode = true;
    }
  }

  enableEditMode() {
    this.editMode = true;
  }

  private getUserDetails() {
    this.userService.getCurrentUser().subscribe(user => {
      this.user = user as UserVO;
    }, error => {
      console.log(error);
    }, () => {

    });
  }

  disableEditMode() {
    this.editMode = false;
    this.getUserDetails();
  }
}
